import { Injectable } from '@angular/core';

import { DocumentAnalysis } from 'app/providers/storage-api/analysis.service';
import { SemantriaAPIService } from '../semantria-api.service';

export interface SemantriaDocumentRequest {
  id: string;
  text: string;
  tags?: string[];
  metadata?: {
    [field: string]: any;
  };
}

export interface SemantriaVersions {
  salience_version: {
    Version: string;
    Component: string;
    Branch: string;
    Tag: string;
    Commit: string;
    Built: string;
    Host: string;
  };
  semantria_version: string;
}

@Injectable()
export class EvaluationService extends SemantriaAPIService {
  evaluateDocuments(
    configurationId: string,
    documents: SemantriaDocumentRequest[]
  ): Promise<DocumentAnalysis[]> {
    const params = {
      using: configurationId,
    };
    return this.post('/evaluate/documents/', documents, {}, params);
  }

  getVersions(): Promise<SemantriaVersions> {
    return this.get('/intrnl/configs/version').then((res: any) => {
      return {
        salience_version: res.salience_version.split(', ').reduce((prev, curr) => {
          const keyValue = curr.split(': ');
          prev[keyValue[0]] = keyValue[1];
          return prev;
        }, {}),
        semantria_version: res.semantria_version,
      };
    });
  }
}
